module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Nine years before")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t12"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("ED")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v(". G")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("REEN")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Blue. Orange. Yellow. Purple.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Neil stared at each color the sunbeams made as they came through the stained glass.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Blue. Orange. Red. Green. Purple. Yellow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Dots of color on his bare skin.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Purple. Red. Yellow. Green. Blue. Orange.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("His white T-shirt looked like a box of crayons.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Orange. Blue. Red. Purple. Green. Yellow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The sunlight pierced the windows and lit up the pulpit with a rainbow.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Green. Purple. Yellow. Blue. Red. Orange.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The colors stained the carpet of the altar steps.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Green. Purple. Orange. Yellow. Red. Blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Looking at the colors had always helped before. Now the colors just reminded Neil of the other times.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Yellow. Please. Purple. Please. Green. Oh, please. Red….")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("When would Brother Gramm finish?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The pastor’s warm slobber bathed Neil"), _c('span', {
    staticClass: "t7"
  }, [_vm._v(".")]), _vm._v(" The man moved his tongue over him. He ran his fingers up and down Neil’s body. The fingertips felt like spiders crawling, creeping.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Gramm finally gasped and collapsed with a little moan, lying on his back across the altar steps. It was almost like he had died.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Neil’s first reaction was to run away.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("But the doors to the sanctuary were locked. Brother Gramm had locked them after they came in. Except for services, the doors were always kept locked because other churches in town had been spray-painted.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("All Neil could do was sit there until Brother Gramm was ready to let him out. He stared at the colors, knowing they weren’t helping him anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Blue. Green. Red….")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Let’s finish putting out those hymnals, shall we?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Gramm’s voice startled Neil. It took him a moment, but he remembered the new hymnals were why the pastor had brought him here in the first place. Brother Gramm was always getting Neil to help him with some chore or another.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("But it always led to “their little secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("That’s what Brother Gramm called it. He would flash his big, toothy smile and say, “Now, Neil, don’t forget. This is our little secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("And who would Neil tell anyway? Who would believe a nine-year-old boy? His mother certainly didn’t when he tried to tell her. His parents thought Brother Gramm Peters was a saint. In fact, the whole congregation felt that way.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Gramm had always been their preacher. Neil had never known another pastor. The tall, broad-shouldered man was everything to their church. He preached loud, fiery sermons on Sunday, then coached the church league softball team in the afternoons. About twice a week, Neil’s mama had Brother Gramm to dinner. Sometimes it was just Neil, his mom and dad, and the pastor, and sometimes other church members joined them. Mama was a good cook, and no one turned down her invitations. The grown-ups laughed at Brother Gramm’s stories while the kids fought to sit on his knee.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("No one saw through him.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Only Neil.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Only Neil knew the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Only Neil shared Brother Gramm’s “little secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Only Neil and the colors.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Red. Green. Blue. Purple. Orange. Yellow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47edcc68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/008.vue
// module id = 75
// module chunks = 0